export const getSubDomain = (value?: string) => {
  const hostname =
    value ?? (typeof location !== 'undefined' ? location.hostname : undefined);

  if (!hostname) return null;

  const mainDomain = hostname.split('.').slice(-2).join('.');
  const subDomain = hostname
    .replace(`.${mainDomain}`, '')
    .replace(/^(http:\/\/|https:\/\/)/, '');

  return subDomain || null;
};
